<template>
    <b-card-code
            title="Új hozzáadása"
    >
        <b-overlay
                :show="loading"
                spinner-variant="primary"
                spinner-type="grow"
                rounded="sm"
        >
            <!-- form -->
            <validation-observer ref="simpleRules">
                <b-form>
                    <b-row>
                        <b-col md="6">
                            <b-form-group
                                    label="Felhasználó"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="felhasználó"
                                        rules="required"
                                        vid="user"
                                >
                                    <v-select
                                            v-model="formData.user"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            label="title"
                                            :clearable="false"
                                            :options="userOptions"
                                            @input="resetForm"
                                    >
                                        <template #no-options>
                                            <span style="">Sajnáljuk, nincs egyező találat.</span>
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group
                                    label="Horgász"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="horgász"
                                        rules="required"
                                        vid="fisherman"
                                >
                                    <b-input-group
                                            :class="errors.length > 0 ? 'is-invalid':null"
                                    >
                                        <v-select
                                                v-model="formData.fisherman"
                                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                label="title"
                                                :clearable="false"
                                                :options="fishermanOptions"
                                        >
                                            <template #no-options>
                                                <span style="">Sajnáljuk, nincs egyező találat.</span>
                                            </template>
                                        </v-select>
                                        <b-input-group-append>
                                            <b-link
                                                    v-b-tooltip.hover
                                                    title="Új horgász létrehozása"
                                                    class="btn btn-secondary"
                                                    @click="showNewFishermanModal"
                                            >
                                                <feather-icon icon="PlusIcon"></feather-icon>
                                            </b-link>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="12">
                            <b-form-group
                                    label="Fogás ideje"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="fogás ideje"
                                        rules="required"
                                        vid="catchTime"
                                >
                                    <flat-pickr
                                            v-model="formData.catchTime"
                                            class="form-control"
                                            :config="flatPickRConfig"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="12" class="mt-1">
                            <h4>Fogás helye</h4>
                        </b-col>

                        <b-col md="6">
                            <b-form-group
                                    label="Vízterület"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="vízterület"
                                        rules="required"
                                        vid="water"
                                >
                                    <v-select
                                            v-model="formData.water"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            label="title"
                                            :clearable="false"
                                            :options="waterOptions"
                                    >
                                        <template #no-options>
                                            <span style="">Sajnáljuk, nincs egyező találat.</span>
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group
                                    label="Hely"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="hely"
                                        rules=""
                                        vid="fishingPlace"
                                >
                                    <b-form-input
                                            v-model="formData.fishingPlace"
                                            :state="errors.length > 0 ? false:null"
                                            placeholder=""
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="12" class="mt-1">
                            <h4>Hal</h4>
                        </b-col>

                        <b-col md="3">
                            <b-form-group
                                    label="Halfaj"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="halfaj"
                                        rules="required"
                                        vid="fishType"
                                >
                                    <v-select
                                            v-model="formData.fishType"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            label="title"
                                            :clearable="false"
                                            :options="fishTypeOptions"
                                    >
                                        <template #no-options>
                                            <span style="">Sajnáljuk, nincs egyező találat.</span>
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="3">
                            <b-form-group
                                    label="Tömeg"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="tömeg"
                                        rules="required"
                                        vid="weight"
                                >
                                    <b-input-group>
                                        <b-form-input
                                                v-model="formData.weight"
                                                type="number"
                                                lang="hu"
                                                :state="errors.length > 0 ? false:null"
                                                :step="0.01"
                                                :min="0"
                                        />
                                        <b-input-group-append>
                                            <b-input-group-text>kg</b-input-group-text>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="3">
                            <b-form-group
                                    label="Hossz"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="hossz"
                                        rules=""
                                        vid="length"
                                >
                                    <b-input-group>
                                        <b-form-input
                                                v-model="formData.length"
                                                type="number"
                                                lang="hu"
                                                :state="errors.length > 0 ? false:null"
                                                :min="0"
                                        />
                                        <b-input-group-append>
                                            <b-input-group-text>cm</b-input-group-text>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="3">
                            <b-form-group
                                    label="Kerület"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="kerület"
                                        rules=""
                                        vid="perimeter"
                                >
                                    <b-input-group>
                                        <b-form-input
                                                v-model="formData.perimeter"
                                                type="number"
                                                lang="hu"
                                                :state="errors.length > 0 ? false:null"
                                                :min="0"
                                        />
                                        <b-input-group-append>
                                            <b-input-group-text>cm</b-input-group-text>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="12">
                            <b-form-group
                                    label="Csali"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="csali"
                                        rules="required"
                                        vid="bait"
                                >
                                    <v-select
                                            v-model="formData.bait"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            label="title"
                                            :clearable="false"
                                            :options="baitOptions"
                                    >
                                        <template #no-options>
                                            <span style="">Sajnáljuk, nincs egyező találat.</span>
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="12" class="mb-1">
                            <validation-provider
                                    #default="{ errors }"
                                    name="visszaengedve"
                                    vid="released"
                            >
                                <b-form-checkbox
                                        v-model="formData.released"
                                        :state="errors.length > 0 ? false:null"
                                >
                                    Visszaengedve?
                                </b-form-checkbox>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-col>

                        <b-col md="12">
                            <b-form-group
                                    label="Verseny"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="verseny"
                                        rules=""
                                        vid="competition"
                                >
                                    <b-form-input
                                            v-model="formData.competition"
                                            :state="errors.length > 0 ? false:null"
                                            placeholder=""
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="12">
                            <b-form-group
                                    label="Beszámoló"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="beszámoló"
                                        rules=""
                                        vid="report"
                                >
                                    <editor
                                            v-model="formData.report"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="12">
                            <b-form-group
                                    label="Idegen kulcs"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="idegen kulcs"
                                        rules=""
                                        vid="foreignKey"
                                >
                                    <b-form-input
                                            v-model="formData.foreignKey"
                                            :state="errors.length > 0 ? false:null"
                                            placeholder=""
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <!-- submit button -->
                        <b-col class="mt-1">
                            <b-button
                                    variant="primary"
                                    type="submit"
                                    class="float-right"
                                    @click.prevent="submitForm"
                            >
                                Mentés
                            </b-button>
                            <cancel-and-g-o-t-o-previous-page class="mr-2"/>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </b-overlay>
        <new-fisherman
                ref="newFishermanModal"
                @refresh-fishermen="refreshFishermen"
        />
    </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
    BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormCheckbox, BInputGroup,
    BInputGroupAppend, BInputGroupText, BLink, BOverlay, VBTooltip,
} from 'bootstrap-vue'
import {
    required,
} from '@validations'
import vSelect from 'vue-select'
import cancelAndGOTOPreviousPage from '@/views/pages/_components/_helper/cancelAndGOTOPreviousPage'
import newFisherman from "@/views/pages/_components/_modal/record-catch/newFisherman";
import editor from '@/views/pages/_components/editor.vue'
import labels from "@/libs/datepicker/labels";
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css';
import {Hungarian} from 'flatpickr/dist/l10n/hu.js'
import {mapGetters} from "vuex";

export default {
    components: {
        BCardCode,
        ValidationProvider,
        ValidationObserver,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
        BFormCheckbox,
        BInputGroup,
        BInputGroupAppend,
        BInputGroupText,
        BLink,
        BOverlay,
        flatPickr,
        editor,
        vSelect,
        cancelAndGOTOPreviousPage,
        newFisherman,
        VBTooltip,
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    data() {
        return {
            role: 'record_catch',
            loading: false,
            formData: {
                user: '',
                fisherman: '',
                fishType: '',
                water: '',
                bait: '',
                catchTime: '',
                weight: '',
                length: '',
                perimeter: '',
                report: '',
                released: false,
                foreignKey: '',
                competition: '',
                fishingPlace: '',
            },
            flatPickRConfig: {
                enableTime: true,
                dateFormat: 'Y-m-d H:i',
                locale: Hungarian,
                allowInput: true
            },
            userOptions: [],
            fishermanOptions: [],
            fishTypeOptions: [],
            waterOptions: [],
            baitOptions: [],
            required,
            labels,
        }
    },
    created() {
        this.loading = true

        this.refreshUser()
        this.resetSelects()
    },
    methods: {
        resetSelects() {
            this.$store.dispatch('fetchFishTypesForSelect').then(response => {
                this.fishTypeOptions = response

                if (this.fishTypeOptions.length) {
                    this.formData.fishType = this.fishTypeOptions[0]
                }
            })

            this.$store.dispatch('fetchWatersForSelect').then(response => {
                this.waterOptions = response

                if (this.waterOptions.length) {
                    this.formData.water = this.waterOptions[0]
                }
            })

            this.$store.dispatch('fetchBaitsForSelect').then(response => {
                this.baitOptions = response

                if (this.baitOptions.length) {
                    this.formData.bait = this.baitOptions[0]
                }
            }).finally(() => {
                this.loading = false
            })
        },
        resetForm(fishermanId = null) {
            this.refreshFishermen()
            this.resetSelects()
            this.formData.catchTime = ''
            this.formData.weight = ''
            this.formData.length = ''
            this.formData.perimeter = ''
            this.formData.report = ''
            this.formData.released = false
            this.formData.foreignKey = ''
            this.formData.competition = ''
            this.formData.fishingPlace = ''
            this.$refs.simpleRules.reset()
        },
        showNewFishermanModal() {
            this.$refs.newFishermanModal.setUser(this.formData.user.value)
            this.$bvModal.show('form-record-catch-new-fisherman-modal')
        },
        refreshUser() {
            this.$store.dispatch('fetchUsersForSelect').then(response => {
                this.userOptions = response

                let userId = this.userID

                if (this.userOptions.length) {
                    Object.keys(response).forEach(key => {
                        if (response[key].value === parseInt(userId)) {
                            this.formData.user = response[key]
                        }
                    })
                }
            }).finally(() => {
                this.refreshFishermen();
            })
        },
        refreshFishermen(fishermanId = null) {
            this.loading = true
            this.fishermanOptions = []
            this.formData.fisherman = ''
            this.$store.dispatch('fetchFishermenForSelect', {user_id: this.formData.user.value}).then(response => {
                this.fishermanOptions = response
                if (fishermanId) {
                    Object.keys(response).forEach(key => {
                        if (response[key].value === fishermanId) {
                            this.formData.fisherman = response[key]
                        }
                    })
                } else {
                    if (this.fishermanOptions.length) {
                        this.formData.fisherman = this.fishermanOptions[0]
                    }
                }
            }).finally(() => {
                this.loading = false
            })
        },
        submitForm() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    // clone formData
                    let fd = {...this.formData}
                    fd.user = this.formData.user.value
                    fd.fisherman = this.formData.fisherman.value
                    fd.fishType = this.formData.fishType.value
                    fd.water = this.formData.water.value
                    fd.bait = this.formData.bait.value

                    this.$store.dispatch('storeRecordCatch', fd).then(response => {
                        this.$helpers.showSuccessToast('Új rekord létrehozva.')

                        this.$acl.canEditPermission(this.role)
                            ? this.$router.push({name: 'modify-record-catch', params: {id: response.data.entity.id}})
                            : this.$router.go(-1)
                    }).catch(error => {
                        if (error.response.status === 422) {
                            this.$refs.simpleRules.setErrors(error.response.data.errors)
                        } else {
                            this.$helpers.showErrorToast(error.toString())
                        }
                    })
                }
            })
        },
    },
    computed: {
        // eslint-disable-next-line no-undef
        ...mapGetters([
            'userID',
        ]),
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
.input-group .v-select {
    flex: 1 1 auto;
}

[dir="ltr"] .input-group:not(.has-validation) .vs__dropdown-toggle:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
</style>
